<template>
  <div :class="{ 'pie__mask': halfCircle }">
    <div class="pie__main">
      <div
        class="pie__wrapper"
        :class="[
          `progress--${halfCircle ? parseInt((percentValue / 1.38)) : percentValue}`,
          { 'progress--success': percentValue <= 39 },
          { 'progress--warning': percentValue > 39 && percentValue <= 79 },
          { 'progress--danger': percentValue >= 80 },
        ]"
      >
        <div class="pie">
          <div class="left__side half__circle"></div>
          <div class="right__side half__circle"></div>
        </div>
        <div class="shadow" />
      </div>
      <span class="pie__percent">{{ percentValue }}%</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PieProgress',
  props: {
    percent: {
      type: Number,
      default: 0
    },

    halfCircle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      percentValue: 0
    }
  },
  methods: {
    renderPie () {
      let timeToStartNote

      setTimeout(() => {
        for (let i = 0; i <= this.percent; i++) {
          ((i) => {
            timeToStartNote = 12 * i
            setTimeout(() => { this.percentValue = i }, timeToStartNote)
          })(i)
        }
      }, 1000)
    }
  },
  mounted () {
    this.renderPie()
  }
}
</script>

<style lang="scss" scoped>
$bg-color: #34495e;
$default-size: 200px;
$numbers: (0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100);

@mixin size($width, $height) {
  height: $height;
  width: $width;
}

@mixin draw-progress ($progress, $color) {
  .pie {

    .half__circle { border-color: $color; }

    .left__side {
      transform: rotate($progress * 3.6deg);
    }

    @if $progress <= 50 {
      .right__side {
        display: none;
      }
    } @else {
      clip: rect(auto, auto, auto, auto);

      .right__side {
        transform: rotate(180deg);
      }
    }
  }
}

.pie__mask {
  height: 158px;
  width: 200px;
  overflow: hidden;

  .pie__wrapper {
    transform: rotate(-130deg);
  }

  .pie__percent {
    top: calc(50% - 10px);
  }
}

.pie__main {
  @include size($default-size, $default-size);
  position: relative;
}

.pie__percent {
  color: $gray-7;
  font-family: 'Montserrat', sans-serif;
  font-size: 36px;
  font-weight: 800;
  left: 0;
  position: absolute;
  text-align: center;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 1;
}

.pie__wrapper {
  @include size($default-size, $default-size);
  display: inline-block;
  position: relative;

  &:nth-child(3n + 1) {
    clear: both;
  }

  .pie {
    @include size(100%, 100%);
    clip: rect(0, $default-size, $default-size, $default-size / 2);
    left: 0;
    position: absolute;
    top: 0;

    .half__circle {
      @include size(100%, 100%);
      border: ($default-size / 25) solid $gray-4;
      border-radius: 50%;
      clip: rect(0, $default-size / 2, $default-size, 0);
      left: 0;
      position: absolute;
      top: 0;
      transition: border .26s;
    }
  }

  .shadow {
    @include size(100%, 100%);
    border: ($default-size / 25) solid $gray-2;
    border-radius: 50%;
  }
}

@each $number in $numbers {
  .pie__wrapper.progress--#{$number} {
    @include draw-progress($number, $gray-4);
  }
}

.pie__wrapper.progress--success .pie .half__circle {
  border-color: $success;
}

.pie__wrapper.progress--warning .pie .half__circle {
  border-color: $warning;
}

.pie__wrapper.progress--danger .pie .half__circle {
  border-color: $error;
}
</style>
